<button
	type="button"
	matRipple
	[matRippleCentered]="true"
	[matRippleColor]="config[color].rippleColor"
	class="au-techno-btn"
	[class.full-width]="fullWidth"
	[ngClass]="config[color].className"
	[ngStyle]="styles"
	[disabled]="disabled"
>
	<ng-content></ng-content>
</button>
